<!-- 下发车辆预存款接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
            <pre slot="pay_url_q_code">{{JSON.stringify(requestBodyForPayUrl, null, 4)}}</pre>
            <pre slot="pay_url_r_code">{{JSON.stringify(responseCodeForPayUrl, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructureForSetPreStore"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S",
                "parkingCode": "190924161838313940964746",
                "recordId": "20190924000022",
                "prestoreAmount": "200",
                "payOrigin": "3",
                "payOriginRemark": "微信",
                "paymentMode": "12",
                "paymentModeRemark": "第三方余额",
                "payUrl": "http://10.10.18.16:8111/upward/v3"
            },
            responseCode: {
                "data": {
                    "prePayKey": "keyZz2CV81lfNeG1I0wq"
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            requestBodyForPayUrl: {
                "biz_content": {
                    "park_code": "2KKN885S",
                    "car_code": "京Y19746",
                    "charge_time": "2019-09-24 16:21:01",
                    "leave_channel_seq": 2,
                    "other_attr": {
                        "chargeTime": "2019-09-24 16:21:01",
                        "chargeBillNumber": "2019092416210210682793",
                        "carChargeDesc": "",
                        "isCanUse": true,
                        "parkAmount": 8,
                        "onlineSearch": 1,
                        "timeoutLength": 0,
                        "carChargeType": 1,
                        "end": "20190924162101",
                        "begin": "20190924161838"
                    },
                    "parking_code": "190924161838313940964746",
                    "park_record_number": "2019092416184434450424",
                    "trader_coupon_list": [{
                        "coupon_discount_value": "0",
                        "coupon_value": "1.0",
                        "coupon_type": "1",
                        "coupon_name": "wdl09240001",
                        "coupon_serial_number": "BWQHE1O4S3N",
                        "is_can_use": "1"
                    }],
                    "total_actual_value": "7.0",
                    "check_in_time": "2019-09-24 16:18:38",
                    "total_park_fee": "8.0",
                    "total_paid_value": "0.0",
                    "total_discount_value": "1.0",
                    "sign": "4725ffc82e8614eeb89fa4f2db0c91ac"
                },
                "charset": "utf-8",
                "command": "REPORT_PAY_NOTICE",
                "device_id": "00000000000000000000000000000000",
                "message_id": "REPORT_PAY_NOTICE20190924162102262",
                "sign": "",
                "sign_type": "MD5",
                "timestamp": "20190924162102262"
            },
            responseCodeForPayUrl: {
                "biz_content": {
                    "code": 0,
                    "msg": "缴费成功",
                },
                "charset": "utf-8",
                "command": "REPORT_PAY_NOTICE_RETURN",
                "message_id": "12312312312313",
                "sign": "",
                "sign_type": "MD5",
                "timestamp": "20190921082941414"
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台下发某个车辆预存款，用于后续车辆自动扣费",
                t_url: this.commonUrls.test+"setPrestoreForFirstPayThenLeave",
                p_url: this.commonUrls.prod+"setPrestoreForFirstPayThenLeave",
                flow: "/static/img/unconsciousPayBeforeLeaving.svg",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'recordId', info2: '是', info3: 'String', info4: '下发记录编号，不超过20个字符。一次调用唯一，每次调用不同，如果调用失败也不同' },
                        { info1: 'prestoreAmount', info2: '是', info3: 'Decimal', info4: '预存款金额' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注(字段长度不得超过20位)' },
                        { info1: 'paymentMode', info2: '是', info3: 'int', info4: '支付方式（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注(字段长度不得超过20位)' },
                        { info1: 'payUrl', info2: '是', info3: 'String', info4: '缴费地址，该url为先付费后离场扣费url。注意：请求第三方方式与平台请求方式不同，详情请看文档和demo' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'prePayKey', info2: '是', info3: 'String', info4: '秘钥，20个字符长。用于支付回调的验签。' },
                        ]
                }],
                PAY_URL_Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'command', info2: '是', info3: 'String', info4: '命令名称，始终为“REPORT_PAY_NOTICE”' },
                        { info1: 'message_id', info2: '是', info3: 'String', info4: '消息ID，本身消息编号,11位' },
                        { info1: 'device_id', info2: '是', info3: 'String', info4: '设备id，32位' },
                        { info1: 'sign_type', info2: '是', info3: 'String', info4: '签名类型，MD5' },
                        { info1: 'sign', info2: '是', info3: 'String', info4: '签名。废弃不用' },
                        { info1: 'charset', info2: '是', info3: 'String', info4: 'UTF-8' },
                        { info1: 'timestamp', info2: '是', info3: 'String', info4: '时间戳（格式：yyyyMMddHHmmss）' },
                        { info1: 'biz_content', info2: '是', info3: 'jsonobject', info4: '业务参数' },
                        ]
                },{
                    titleName: 'biz_content',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'park_record_number', info2: '是', info3: 'String', info4: '停车场端的整次停车的唯一编码' },
                        { info1: 'parking_code', info2: '否', info3: 'String', info4: '线上的整次停车的唯一编码,如果没有使用智慧停车微信平台,则该字段为””' },
                        { info1: 'car_code', info2: '是', info3: 'Integer', info4: '当前缴费的车牌号码' },
                        { info1: 'check_in_time', info2: '是', info3: 'String', info4: '进场时间,格式: yyyy-MM-dd HH:mm:ss' },
                        { info1: 'charge_time', info2: '是', info3: 'String', info4: '计费时间,格式: yyyy-MM-dd HH:mm:ss' },
                        { info1: 'park_code', info2: '是', info3: 'Decimal', info4: '停车场编码' },
                        { info1: 'total_park_fee', info2: '否', info3: 'String', info4: '总停车费用,保留两位小数,单位:元' },
                        { info1: 'total_paid_value', info2: '是', info3: 'String', info4: '已缴金额' },
                        { info1: 'total_discount_value', info2: '是', info3: 'String', info4: '本次缴费可优惠金额' },
                        { info1: 'total_actual_value', info2: '是', info3: 'String', info4: '应缴金额,(用户本次停车要缴的钱)' },
                        { info1: 'other_attr', info2: '否', info3: 'String', info4: '上报的缴费通知,在实现缴费时带下来' },
                        { info1: 'sign', info2: '否', info3: 'String', info4: '签名值。为sign=MD5加密(prePayKey+冒号+recordId)，加密后的值应转换为32位小写字符串，如MD5("prePayKey:recordId") = c2d404708a925d563fb794929e04f36c' },
                        { info1: 'leaveChannelSeq', info2: '是', info3: 'String', info4: '离场通道序列号' },
                        { info1: 'trader_coupon_list', info2: '否', info3: 'JSONObject', info4: '优惠列表' },
                    ]
                },{
                    titleName: 'trader_coupon_list',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'coupon_serial_number', info2: '是', info3: 'String', info4: '电子券编码' },
                        { info1: 'is_can_use', info2: '否', info3: 'String', info4: '是否可用，0不可用 1可用' },
                        { info1: 'coupon_name', info2: '是', info3: 'String', info4: '电子券名称' },
                        { info1: 'coupon_type', info2: '是', info3: 'String', info4: '抵扣类型' },
                        { info1: 'coupon_value', info2: '是', info3: 'String', info4: '券抵扣金额' },
                        { info1: 'coupon_discount_value', info2: '是', info3: 'String', info4: '' }
                    ]
                }],
                PAY_URL_R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'command', info2: '是', info3: 'String', info4: '命令名称，始终为“REPORT_PAY_NOTICE_RETURN”' },
                        { info1: 'message_id', info2: '是', info3: 'String', info4: '消息ID，本身消息编号,11位' },
                        { info1: 'sign_type', info2: '是', info3: 'String', info4: '签名类型，MD5' },
                        { info1: 'sign', info2: '是', info3: 'String', info4: '签名。废弃不用' },
                        { info1: 'charset', info2: '是', info3: 'String', info4: 'UTF-8' },
                        { info1: 'timestamp', info2: '是', info3: 'String', info4: '时间戳（格式：yyyyMMddHHmmss）' },
                        { info1: 'biz_content', info2: '是', info3: 'jsonobject', info4: '业务参数' },
                        ]
                },{
                    titleName: 'biz_content',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'code', info2: '是', info3: 'String', info4: '返回码，0表示成功 非0表示失败' },
                        { info1: 'msg', info2: '是', info3: 'String', info4: '返回消息' }
                    ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/setPrestoreForFirstPayThenLeave.vue